import {Component, OnDestroy} from '@angular/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {SoService} from '../_services/so.service';

@Component({
  selector: 'app-so',
  templateUrl: './so.component.html',
  styleUrls: ['./so.component.scss']
})

export class SoComponent implements OnDestroy {

  soActive = false;

  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(
    private smService: SoService,
  ) {
    this.getSmActive();
  }

  ngOnDestroy(): void {
    this.smService.newSoActive('');
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  // ********************************************************************************************************
  // LOAD DATA
  // ********************************************************************************************************

  private getSmActive(): void {
    this.smService.onNewSoActive()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (sm) => {
          this.soActive = sm !== '';
        }
      );
  }

  // ********************************************************************************************************
  // UI
  // ********************************************************************************************************

  onClose(): void {
    this.smService.newSoActive('');
  }

}
